import { StringMap } from '@angular/compiler/src/compiler_facade_interface';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationError, NavigationCancel } from '@angular/router'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styles: []
})
export class AppComponent implements OnInit {
  title = 'FrontEND';
  isLoading: boolean = false;

  constructor(public router: Router) {
    this.router.events.subscribe(e => {
      if (e instanceof NavigationStart) {
        this.isLoading = true;
      }

      if (e instanceof NavigationEnd || e instanceof NavigationError || e instanceof NavigationCancel ) {
        this.isLoading = false;
      }
    })
  }

  ngOnInit(): void {}
}
